import { IOS_DEVICE } from 'constants/global.constants'
import styled, { css } from 'styled-components'

const iOS = IOS_DEVICE.test(navigator.userAgent)

export const Container = styled.div`
  width: 100%;
  min-width: 0;
  height: 100vh;
  display: flex;
  flex-direction: row;
  background-color: #fafcff;

  ${iOS &&
  css`
    height: auto;
  `}
`
interface IContentProps {
  isSidebarOpen: boolean
}

export const Content = styled.div<IContentProps>`
  box-sizing: border-box;
  flex: 1 1 auto;
  min-width: 0;
  height: 100vh;
  width: auto;
  transition: margin-left 0.5s ease-in-out;
  margin: 0 auto;
  padding: ${({ isSidebarOpen }) => (isSidebarOpen ? '0 24px' : '0 5%')};
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  @media (max-width: 992px) {
    display: flex;
    box-sizing: border-box;
    padding-top: 60px;
  }
  @media (max-width: 768px) {
    display: block;
    place-items: start;
    height: 100dvh;
  }

  ${iOS &&
  css`
    padding: 0 5%;
  `}
`
